import { KoobContainer, KoobPageHeader } from '@koob/ui';
import { useParams, useSearchParams } from 'react-router-dom';
import { useAsync } from 'react-async';
import { useTranslation } from 'react-i18next';
import { getTrip } from '../../../api/trip';
import ComposeChatTrip from '../../TripDesigner/Chat/ComposeChatTrip';
import { Formik } from 'formik';
import KoobLayout from '../../../components/Koob/KoobLayout';
import React from 'react';

export default function TripChat() {
  const { tripId } = useParams();
  const [searchParams] = useSearchParams();
  const { t } = useTranslation('pages');

  const { data: tripData, reload } = useAsync({
    promiseFn: getTrip,
    tripId,
  });
  const trip = tripData?.data;

  return (
    <KoobLayout
      header={
        <KoobPageHeader
          title={trip && (trip.name || t('untitledTrip'))}
          breadcrumbs={[{ label: t('folders:title'), to: '/folders' }]}
        />
      }
    >
      <KoobContainer>
        <Formik initialValues={trip ?? {}} onSubmit={() => {}}>
          <ComposeChatTrip
            tripId={tripId}
            reloadTrip={reload}
            trip={trip}
            initialQuestion={searchParams.get('question') ?? undefined}
          />
        </Formik>
      </KoobContainer>
    </KoobLayout>
  );
}
